import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { IconUser, IconBookmark, IconStar, IconMusic, IconUserCircle } from '@tabler/icons-react';
import { ROUTES } from '../constants/routes';
import styles from './ProfileNavigation.module.css';

const ProfileNavigation: React.FC = () => {
  const location = useLocation();
  
  const isActive = (path: string) => {
    return location.pathname === path;
  };
  
  return (
    <div className={styles.navigation}>
      <NavLink 
        to={ROUTES.USER_PROFILE}
        className={isActive(ROUTES.USER_PROFILE) ? styles.active : styles.navItem}
        end
      >
        <IconUser size={20} />
        <span>Vue d'ensemble</span>
      </NavLink>
      
      <NavLink 
        to={ROUTES.PERSONAL_INFO}
        className={isActive(ROUTES.PERSONAL_INFO) ? styles.active : styles.navItem}
      >
        <IconUserCircle size={20} />
        <span>Informations personnelles</span>
      </NavLink>
      
      <NavLink 
        to={ROUTES.SAVED_EVENTS}
        className={isActive(ROUTES.SAVED_EVENTS) ? styles.active : styles.navItem}
      >
        <IconBookmark size={20} />
        <span>Événements sauvegardés</span>
      </NavLink>
      
      <NavLink 
        to={ROUTES.INTERESTED_EVENTS}
        className={isActive(ROUTES.INTERESTED_EVENTS) ? styles.active : styles.navItem}
      >
        <IconStar size={20} />
        <span>Événements intéressants</span>
      </NavLink>
      
      <NavLink 
        to={ROUTES.STAFF_PROFILE}
        className={isActive(ROUTES.STAFF_PROFILE) ? styles.active : styles.navItem}
      >
        <IconMusic size={20} />
        <span>Profil Staff</span>
      </NavLink>
    </div>
  );
};

export default ProfileNavigation;
